const $filtersForm = $('[data-filters-form]');

export const initFiltersMenu = () => {
  /** This will close any filter that is open. */
  const closeFilterMenu = () => {
    $('[aria-haspopup]').attr('aria-expanded', 'false');
    $('[role="menu"]').removeClass('open');
  };

  /** Opens specified filter, closing any fiters already open. */
  const openFilterMenu = ($filter) => {
    closeFilterMenu();
    $filter.find('[aria-haspopup]').attr('aria-expanded', 'true');
    $filter.find('[role="menu"]').addClass('open');

    // for horizontal scroll open subMenu on the good position
    if ($filter.closest('.horizontal_scroll').length > 0) {
      $filter.find('[role="menu"]').css('left', $filter[0].getBoundingClientRect().left);
    }
  };

  $filtersForm.on('click', '[data-filter] [aria-haspopup]', (event) => {
    const $filterToggle = $(event.target);
    const $filter = $filterToggle.closest('[data-filter]');

    if ($filterToggle.attr('aria-expanded') === 'false') {
      openFilterMenu($filter);
    } else {
      closeFilterMenu();
    }
  });

  $filtersForm.on('click', 'button', (event) => {
    const $buttonClicked = $(event.target);

    // Necessary for cross-browser blur events/keyboard controls.
    $(event.target).focus();

    // If we're about to submit the form, we want to disable the unneeded hidden input for this specific filter.
    if ($buttonClicked.attr('name')) {
      const $input = $filtersForm.find(`input[name="${$buttonClicked.attr('name')}"][type="hidden"]`);
      $input.attr('disabled', 'disabled');
    }
  });

  // Close filter when focus moves out of submenu. https://stackoverflow.com/a/60094794
  $filtersForm.on('blur', '[data-filter]', (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      closeFilterMenu();
    }
  });

  // Remove unselected class from tags layout filters:: if filter is not active
  $('.menu_wrap').each((index, record) => {
    const selectedValue = $(record).find('input[type=hidden]').val();
    if (selectedValue !== '' && selectedValue.indexOf('all') < 0) {
      $(record).find('button').removeClass('unselected');
    }
  });

  // Keyboard Controls
  $filtersForm.on('keydown', '[data-filter]', (event) => {
    const keyArrowDown = (event.key === 'ArrowDown' || event.key === 'Down');
    const keyArrowUp = (event.key === 'ArrowUp' || event.key === 'Up');
    const keyEscape = (event.key === 'Escape' || event.key === 'Esc');

    if (!(keyArrowDown || keyArrowUp || keyEscape)) {
      return;
    }

    const $filter = $(event.target).closest('[data-filter]');
    const $filterToggle = $filter.find('[aria-haspopup]');
    const $filterButtons = $filter.find('button');

    const focusIndex = Array.prototype.indexOf.call($filterButtons, event.target);

    if (focusIndex < 0) {
      return;
    }

    if (keyEscape) {
      closeFilterMenu();
      $filterToggle.focus();
    }

    if (event.target === $filterToggle.get(0)) {
      if (keyArrowDown) {
        openFilterMenu($filter);
      } else if (keyArrowUp) {
        closeFilterMenu();
        event.preventDefault();
        return;
      }
    }

    if (keyArrowUp || keyArrowDown) {
      event.preventDefault();

      const offset = keyArrowUp ? -1 : 1;
      const btnIndex = ((focusIndex + offset) + $filterButtons.length) % ($filterButtons.length);

      $filterButtons.get(btnIndex).focus();
    }
  });
};

export default initFiltersMenu;
